import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import FoldableTagList from '@wix/da-ds/pkg/TagList/FoldableTagList';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import License from '../../../License';
import TextRenderer from '../../../TextRenderer/TextRenderer';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import MatureIndicator from '../../../SubmissionDetails/_partials/MatureIndicator';
import s from './Literature.scss';
export const LiteratureDetails = ({ deviation , deviation: { isMature , author , publishedTime , extended: { license , descriptionText , tags  } = {}  } , className , contentClassName  })=>{
    var _descriptionText_html;
    const { t  } = useTranslation();
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const { isSubscribedButBlocked , needsSubscription  } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    const isDescriptionTextShown = !!(descriptionText === null || descriptionText === void 0 ? void 0 : (_descriptionText_html = descriptionText.html) === null || _descriptionText_html === void 0 ? void 0 : _descriptionText_html.markup) && !isBlocked;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, isExtendedLoaded && /*#__PURE__*/ React.createElement(React.Fragment, null, tags && /*#__PURE__*/ React.createElement("div", {
        className: s['tags']
    }, /*#__PURE__*/ React.createElement(FoldableTagList, {
        tags: tags,
        moreLabel: t('common.more'),
        lessLabel: t('common.less')
    })), isDescriptionTextShown && /*#__PURE__*/ React.createElement(TextRenderer, {
        // TODO: search and remove all instances of 'as unknown as PapiEditorText'
        // when PapiExtendedDeviation.descriptionText is PapiEditorText and not string in papi types
        textContent: descriptionText,
        className: s['description'],
        legacyTheme: "literature-description"
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['misc']
    }, isMature && /*#__PURE__*/ React.createElement(MatureIndicator, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['license']
    }, /*#__PURE__*/ React.createElement(License, {
        license: license,
        author: author,
        publishedTime: publishedTime,
        showSymbol: false
    })))));
};
LiteratureDetails.displayName = 'LiteratureDetails';
export default LiteratureDetails;
